(() => {
 const xs = value => /^iphone\s*xs\s*max$/i.test(value.trim());
 function setup() {
  document.querySelectorAll('form[is="facet-form"]').forEach(form => {
   const boxes=[...form.querySelectorAll('input[type="checkbox"]')].filter(box=>xs(box.value));
   if(!boxes.length)return;
   const canonical=boxes.find(box=>box.value==='iPhone XS Max')||boxes[0];
   const checked=boxes.some(box=>box.checked);
   const enabled=boxes.some(box=>!box.disabled);
   for(const box of boxes){
    const label=form.querySelector(`label[for="${CSS.escape(box.id)}"]`);
    if(box===canonical){
     const text=boxes.length>1?'iPhone XS Max':label?.textContent.replace(/iPhone Xsmax/gi,'iPhone XS Max');
     if(label && label.textContent!==text)label.textContent=text;
     box.checked=checked;box.disabled=!enabled;
    }else{
     box.hidden=true;box.tabIndex=-1;box.setAttribute('aria-hidden','true');box.disabled=!enabled;
     if(label)label.hidden=true;
     if(box.closest('.checkbox-container'))box.closest('.checkbox-container').hidden=true;
    }
   }
   canonical._smdXsAliases=boxes.filter(box=>box!==canonical);
   const chips=[...document.querySelectorAll('.removable-facet')].filter(chip=>/iPhone\s*XS\s*Max/i.test(chip.textContent));
   chips.forEach((chip,i)=>{
    if(!/iPhone\s*XS\s*Max/i.test(chip.textContent))return;
    const link=chip.querySelector('a');
    if(!link)return;
    const url=new URL(link.href),name=canonical.name;
    const keep=url.searchParams.getAll(name).filter(value=>!xs(value));
    url.searchParams.delete(name);keep.forEach(value=>url.searchParams.append(name,value));link.href=url.href;
    link.setAttribute('aria-label','Remove filter: iPhone XS Max');
    chip.hidden=i>0;
    [...chip.childNodes].filter(node=>node.nodeType===3).forEach(node=>{
     const text=node.textContent.replace(/iPhone Xsmax/gi,'iPhone XS Max');
     if(node.textContent!==text)node.textContent=text;
    });
   });
  });
  document.querySelectorAll('.smd-home-reviews a[href="#judgeme_product_reviews"]').forEach(link=>{
   link.href=(window.Shopify?.routes?.root||'/')+'pages/reviews';
  });
 }
 // Synchronize both original source values before native facet-form reads FormData.
 document.addEventListener('change',event=>{
  const box=event.target;
  if(box._smdXsAliases)box._smdXsAliases.forEach(alias=>alias.checked=box.checked);
 },true);
 let queued=false;
 const observer=new MutationObserver(records=>{
  if(!records.some(record=>record.addedNodes.length)||queued)return;
  queued=true;queueMicrotask(()=>{queued=false;setup();});
 });
 function init(){setup();observer.observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
